import { CHANNEL_TYPE } from "vue-app/types/enums";

export function isMessageValid({ editorType, message }) {
  const isDndEditor = editorType === CHANNEL_TYPE.EMAIL;

  if (isDndEditor && message.subject === "") {
    window.showToast("Please add message subject", "warn");
  }

  return true;
}
